export default (state = {}, {lastPeriodId}: any) => {
  return {
    ...state,
    lastPeriodId,
  };
};
